<template>
  <form action="https://www.paypal.com/cgi-bin/webscr" id="frmpayment" method="post" name="frmpayment">
    <input name="business" type="hidden" value="paypal@jikatel.com">
    <input name="cmd" type="hidden" value="_xclick">
    <input name="hosted_button_id" type="hidden" value="WXR6XLYG824JA">
    <input name="on0" type="hidden" value="">
    <input name="item_name" type="hidden" :value="packageName">
    <input name="item_number" type="hidden" value="">
    <input name="custom" type="hidden" :value="customData">
    <input name="credits" type="hidden" value="">
    <input name="userid" type="hidden" value="">
    <input name="amount" type="hidden" :value="amt">
    <input name="cpp_header_image" type="hidden" value="">
    <input name="no_shipping" type="hidden" value="1">
    <input name="currency_code" type="hidden" value="USD">
    <input name="handling" type="hidden" value="0">
    <input name="cancel_return" type="hidden" :value="cancelUrl">
    <input name="return" type="hidden" :value="successUrl">
  </form>
</template>

<script>
export default {
  props: {
    packageName: {
      required: true
    },
    amt: {
      required: true
    },
    customData: {
      required: true
    },
  },
  data () {
    return {
      successUrl: process.env.VUE_APP_MAIN_FRONTEND_DOMAIN + '/home/successful-payment',
      cancelUrl:  process.env.VUE_APP_MAIN_FRONTEND_DOMAIN + '/home/cancelled-payment',
    }
  },
  mounted() {
    //console.log('this.baseBackendDomain', this.baseBackendDomain)
    document.getElementById('frmpayment').submit();
  }
}
</script>
